import $script from 'scriptjs'

export function ensureRecaptcha(callback, onError) {
  $script.ready(
    'recaptcha',
    () => {
      // script is ready or load failed
      if (window.grecaptcha?.ready) {
        window.grecaptcha.ready(callback)
      } else {
        onError && onError()
      }
    },
    () => {
      // haven't initiated script load, load it now
      $script(
        'https://www.google.com/recaptcha/api.js',
        'recaptcha',
      )
    },
  )
}

// For requests made outside a form component, so there's no div of their own
// to render the invisible widget into: renders one shared widget into an
// element on <body> on first use (its badge is hidden by .grecaptcha-badge),
// then resolves each call with a fresh token. Rejects if the reCAPTCHA script
// fails to load.
let sharedWidgetId
let resolveSharedToken

export function getRecaptchaToken() {
  return new Promise((resolve, reject) => {
    ensureRecaptcha(
      () => {
        if (sharedWidgetId === undefined) {
          const container = document.createElement('div')
          document.body.appendChild(container)
          sharedWidgetId = window.grecaptcha.render(container, {
            sitekey: process.env.REACT_APP_PLICKERS_RECAPTCHA_SITE_KEY,
            size: 'invisible',
            callback: (token) => resolveSharedToken && resolveSharedToken(token),
          })
        }
        resolveSharedToken = resolve
        // tokens are single-use, so reset before every execute
        window.grecaptcha.reset(sharedWidgetId)
        window.grecaptcha.execute(sharedWidgetId)
      },
      () => reject(new Error('reCAPTCHA failed to load')),
    )
  })
}
